import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import moment from 'moment'
import VueRouter from 'vue-router'
import router from './router'
import VMdDateRangePicker from 'v-md-date-range-picker'
import FunctionalCalendar from 'vue-functional-calendar'

import store from '../store/index'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueChart from 'vue-chart-js'
import VueApexCharts from 'vue-apexcharts'

import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue'
import exportingInit from 'highcharts/modules/exporting'
import mapInit from 'highcharts/modules/map'
import loadFunnel from 'highcharts/modules/funnel'
import loadTimeline from 'highcharts/modules/timeline'
import mapData from '@highcharts/map-collection/custom/usa-and-canada.geo.json'
import mapDataWorld from '@highcharts/map-collection/custom/world.geo.json'


import VueExcelXlsx from "vue-excel-xlsx"
import ErrorsLogChecker from "@/plugins/ErrorLogsChecker";

Vue.use(FunctionalCalendar, {
  dayNames: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']
})

Vue.use(VueExcelXlsx)

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

Vue.use(VueRouter)

Vue.use(VueAxios, axios)
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })
Vue.use(VMdDateRangePicker)
Vue.use(VueGoogleMaps, {
  load: {
    language: 'us'
  }
})
Vue.use(VueChart)

Vue.use(HighchartsVue)
exportingInit(Highcharts)
mapInit(Highcharts)
loadFunnel(Highcharts)
loadTimeline(Highcharts)
Highcharts.maps['geoSalesReport'] = mapData
Highcharts.maps['geoSalesReportWorld'] = mapDataWorld

Vue.config.productionTip = false

Vue.filter('formatPhone', function(value) {
  let cleaned = ('' + value).replace(/\D/g, '');
  let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    let intlCode = (match[1] ? '+1 ' : '');
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return value;
})

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(value).format('MM/DD/YYYY')
  }
})

Vue.filter('formatDateTime', function(value) {
  if (value) {
    return moment(value).format('MM/DD/YYYY HH:mm:ss')
  }
})

Vue.filter('formatPrice', function(value) {
  if (value) {
    //$1,234.56
    let val = (value / 1).toFixed(2)
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  } else {
    return 0
  }
})

Vue.filter('formatPriceAbs', function(value) {
  if (value) {
    //$1,234.56
    let val = (Math.abs(value) / 1).toFixed(2)
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  } else {
    return 0
  }
})

Vue.filter('formatFloat', (value) => {
  if (value) {
    //1,234.56
    let val = Math.round10(value, -2)
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  } else {
    return 0
  }
})

Vue.filter('formatFloatAbs', (value) => {
  if (value) {
    //1,234.56
    let val = Math.round10(Math.abs(value), -2)
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  } else {
    return 0
  }
})

let err_checker = new ErrorsLogChecker(router)
err_checker.check_logs()


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
